import { gql } from "lib/apolloClient";

export const upsertFeedbackStatusMutation = gql`
  mutation upsertFeedbackStatus($input: [UpsertVoteInput!]) {
    platform {
      upsertVote(input: $input) {
        myVote
      }
    }
  }
`;

export const updateAIFeedbackCommentMutation = gql`
  mutation updateAIFeedbackComment($input: UpdateAIUsageMetricsInput!) {
    ai {
      updateAIUsageMetrics(input: $input) {
        isSuccess
      }
    }
  }
`;
